import { render, staticRenderFns } from "./AssignWorkPeriodContainer.vue?vue&type=template&id=9938f79e&scoped=true&"
import script from "./AssignWorkPeriodContainer.vue?vue&type=script&lang=ts&"
export * from "./AssignWorkPeriodContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938f79e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
